import { createSlice } from "@reduxjs/toolkit";

export const getSavedCollapsedState = () =>
    localStorage.getItem("collapsed") === "true";

export const CollapsedSlice = createSlice({
    name: "collapsed",
    initialState: {
        state: getSavedCollapsedState(),
    },
    reducers: {
        toggleCollapsed: (state) => {
            state.state = !state.state;
            localStorage.setItem("collapsed", state.state ? "true" : "false");
        },
        setCollapsed: (state, action) => {
            const payload = action.payload;
            const collapsed =
                typeof payload === "object" ? payload.collapsed : payload;
            const persist =
                typeof payload === "object" ? payload.persist !== false : true;

            state.state = collapsed;

            if (persist) {
                localStorage.setItem("collapsed", collapsed ? "true" : "false");
            }
        },
    },
});

export const { toggleCollapsed, setCollapsed } = CollapsedSlice.actions;

export default CollapsedSlice.reducer;
